var n = /* @__PURE__ */ ((o) => (o[o.MintPopup = 0] = "MintPopup", o[o.AccountLogin = 1] = "AccountLogin", o[o.AccountSetting = 2] = "AccountSetting", o[o.SuccessPopup = 3] = "SuccessPopup", o))(n || {}), c = /* @__PURE__ */ ((o) => (o.ChronoMerge = "ChronoMerge", o.Conjunction = "Conjunction", o.Expedition = "Expedition", o.StarMint = "StarMint", o.NoCampaign = "NoCampaign", o))(c || {});
export {
  c as AdeptusCampaignType,
  n as AdeptusInputMode
};
//# sourceMappingURL=adeptus.js.map
